import * as _ from 'lodash-es';
import { assertDefined } from './assertsF/assertDefinedF.mts';
export const expBackoffDefaultsH = { backoffBaseMs: 60 * 1000, recoveryPeriodMs: 1000 * 60 * 60 * 24 };
export const getExpBackoffLimited = ({ cache_key, rlHistH, backoffBaseMs = expBackoffDefaultsH.backoffBaseMs, recoveryPeriodMs = expBackoffDefaultsH.recoveryPeriodMs, backoffCapMs = recoveryPeriodMs, silencedSample, maxSilencedSamples = 10, }) => {
    assertDefined(rlHistH);
    let rec = rlHistH[cache_key];
    const now = _.now();
    let backoffNo = -1;
    let numSilenced = 0;
    let lastRunAtMs = 0;
    if (rec) {
        ;
        ({ lastRunAtMs, backoffNo, numSilenced } = rec);
        const minRecovResetMs = now - recoveryPeriodMs;
        if (lastRunAtMs < minRecovResetMs) {
            delete rlHistH[cache_key];
            rec = undefined;
        }
    }
    if (rec) {
        // cap the exponential at backoffCapMs (default = recoveryPeriodMs, ~daily) so a PERSISTENT error
        // keeps reminding once/day instead of fading below daily as 2^backoffNo grows unbounded.
        const backoffWaitMs = Math.min(backoffBaseMs * Math.pow(2, backoffNo), backoffCapMs);
        const mustWaitUntilMs = lastRunAtMs + backoffWaitMs;
        const silencedForMs = mustWaitUntilMs - now;
        const isLimited = silencedForMs > 0;
        if (isLimited) {
            numSilenced += 1;
            rec.numSilenced += 1;
            if (silencedSample !== undefined) {
                ;
                (rec.silencedSamples || (rec.silencedSamples = [])).push(silencedSample);
                if (rec.silencedSamples.length > maxSilencedSamples)
                    rec.silencedSamples.length = maxSilencedSamples;
            }
            return { isLimited, backoffNo, numSilenced };
        }
    }
    const prevSilencedSamples = rec?.silencedSamples;
    backoffNo += 1;
    rlHistH[cache_key] = {
        numSilenced: 0,
        lastRunAtMs: now,
        backoffNo,
    };
    return { isLimited: false, backoffNo, numSilenced, silencedSamples: prevSilencedSamples };
};
